module.exports = __webpack_public_path__ + "static/amazon-or-ebay-6f0a20aacdcbfbb35c3fa773a6ddc97e.png";